import React from 'react';
import './Styles.css';
import { CheckboxInput } from '@ids/react-checkbox';

const CheckBox = ({ label, onChange, checked, checkBoxId, disabled = false, cssClasses }) => {
  const innerOnChange = () => {
    if (disabled) return;
    onChange();
  };

  return (
    <>
      <div className={`checkbox-container ${cssClasses}`}>
        <CheckboxInput id={checkBoxId} checked={checked} onChange={innerOnChange} disabled={disabled} />
        <label className="if" htmlFor={checkBoxId}>
          {label}
        </label>
      </div>
    </>
  );
};

export default CheckBox;
